import React from "react";

/**
 * Fill color defaults to the color of the current text.
 * To change the fill color, apply a text color utility class
 * to the parent element or to the icon itself,
 * e.g. `className="text-blue-500"`
 */

const CheckIcon = ({ className = "" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" className={`bi bi-check ${className}`}>
            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
        </svg>
    );
};

export default CheckIcon;
